import Collapse from "@material-ui/core/Collapse";
import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
// import Paper from '@material-ui/core/Paper';
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import Select from "react-select";
import { bindActionCreators } from "redux";
import { AttendancePolicyData, CommonReducerAction, setHelperText } from "../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../Actions/LanguageAction";
import CheckImg from "../../../../../Assets/Images/aaa.png";
import FloatValues from "../../../../../Component/FloatValues";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
});

class Absentieesm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isabsenteeismrule: false,
      attendancepolicyid: null,
      absenteeismtypeid: null,
      absenteeismactionid: null,
      absenteeismleaveid: { displayname: null, displayvalue: null },
      absenteeismleavecount: 0,
      LeaveType: props.LeaveType,
      // LeaveType: [
      //     { displayname: "Leave Type 1", displayvalue: 1 },
      //     { displayname: "Leave Type 2", displayvalue: 2 }
      // ]
    };
  }

  componentDidMount() {
    this.props.onRef({
      onNext: this.validateNext,
    });
    const { absenteeism } = this.props.InitAttendancePolicy;
    let absenteeismleaveid;
    Object.keys(this.state).map((key) => {
      if (key == "absenteeismleaveid") {
        absenteeismleaveid = this.state.LeaveType.find(
          (x) => x.displayvalue == absenteeism.absenteeismleaveid,
        );
      } else {
        this.state[key] = absenteeism[key] !== undefined ? absenteeism[key] : this.state[key];
      }
    });
    this.setState({
      absenteeismleaveid,
      isabsenteeismrule: this.props.InitAttendancePolicy.isabsenteeismrule,
    });
  }

  componentWillUnmount() {
    this.props.StepError(3, false);
  }

  validateNext = () => {
    let isError = false;
    if (this.state.isabsenteeismrule) {
      if (!this.state.absenteeismtypeid) {
        this.showError("Please select an auto action");
        isError = true;
      } else {
        switch (this.state.absenteeismtypeid) {
          case 1: {
            if (!this.state.absenteeismactionid) {
              this.showError(
                "Please select auto action for 'employee forgot to clock attendance'",
              );
              isError = true;
            }
            break;
          }
          case 2: {
            if (!this.state.absenteeismactionid) {
              this.showError(
                "Please select auto action for 'employee was on Leave'",
              );
              isError = true;
            } else if (!this.state.absenteeismleaveid) {
              this.showError("Please select a leave type");
              isError = true;
            } else if (this.state.absenteeismleavecount == 0) {
              this.showError("Please add a leave count");
              isError = true;
            }
            break;
          }
          default:
            break;
        }
      }
    }

    this.props.StepError(3, isError);

    if (isError) return false;
    this.props.click();
  };

  showError = (error) => {
    this.props.enqueueSnackbar(error, { variant: "error" });
  };

  handleChange(name, max, event) {
    switch (name) {
      case "isabsenteeismrule": {
          if (max == this.state.isabsenteeismrule) return false;
          this.setState(
            {
              isabsenteeismrule: max,
              absenteeismtypeid: null,
              absenteeismactionid: null,
              absenteeismleaveid: null,
              absenteeismleavecount: 0,
            },
            () => this.UpdateReducer(),
          );
          break;
        }
      case "absenteeismtypeid":
        {
          if (max == this.state.absenteeismtypeid) return false;
          this.setState(
            {
              absenteeismtypeid: max,
              absenteeismactionid: null,
              absenteeismleaveid: null,
              absenteeismleavecount: 0,
            },
            () => this.UpdateReducer(),
          );
          break;
        }
      case "absenteeismactionid":
        {
          if (max == this.state.absenteeismactionid) return false;
          this.setState(
            {
              absenteeismactionid: max,
              absenteeismleaveid: null,
              absenteeismleavecount: 0,
            },
            () => this.UpdateReducer(),
          );
          break;
        }
      case "absenteeismleaveid":
        {
          console.log(
            "absenteeismleaveid: ",
            max,
            this.state.absenteeismleaveid,
          );
          if (max == this.state.absenteeismleaveid) {
            console.log("absenteeismleaveid11: ");
            return false;
          }
          this.setState(
            { absenteeismleaveid: max, absenteeismleavecount: 0 },
            () => this.UpdateReducer(),
          );
          break;
        }
      case "absenteeismleavecount":
        {
          //     var numbers = /^[0-9]+$/;
          //     if (arg[0].target.value.match(numbers)) {
          let absenteeismleavecount;
          if (
            Number(event.target.value) > Number(max)
            || Math.sign(event.target.value) == -1
          ) {
            absenteeismleavecount = this.state.absenteeismleavecount;
          } else absenteeismleavecount = Number(event.target.value);
          this.setState({ absenteeismleavecount }, () => this.UpdateReducer());
          // }
        }
        break;
      default:
        break;
    }
  }

  UpdateReducer = () => {
    this.props.AttendancePolicyData({
      ...this.props.InitAttendancePolicy,
      isabsenteeismrule: this.state.isabsenteeismrule,
      absenteeism: {
        absenteeismtypeid: this.state.absenteeismtypeid,
        absenteeismactionid: this.state.absenteeismactionid,
        absenteeismleaveid: this.state.absenteeismleaveid
          ? this.state.absenteeismleaveid.displayvalue
          : null,
        absenteeismleavename: this.state.absenteeismleaveid
          ? this.state.absenteeismleaveid.displayname
          : null,
        absenteeismleavecount: this.state.absenteeismleavecount,
      },
    });
  };

  RenderLeaveDeduct = () => (
    <span>
      <FormattedMessage
        id="LbChooseleavetype"
        defaultMessage="Choose leave type "
      />
      <span className="width260 inline-block margin-left-8">
        <Select
          autofocus
          placeholder="Select"
          options={this.state.LeaveType}
          getOptionLabel={(option) => option.displayname}
          getOptionValue={(option) => option.displayvalue}
          onChange={this.handleChange.bind(this, "absenteeismleaveid")}
          value={this.state.absenteeismleaveid}
        />
      </span>
      <br />
      <br />

      <FormattedMessage
        id="LbNumberLeaveDeduct"
        defaultMessage="Number of leaves to deduct"
      />
      <FloatValues
        width="100px"
        min="0"
        max="31"
        field="absenteeismleavecount"
        step="0.25"
        onChange={this.handleChange.bind(this, "absenteeismleavecount", 31)}
        value={this.state.absenteeismleavecount}
        defaultvalue={this.state.absenteeismleavecount}
        disabled={!this.state.absenteeismleaveid}
        title={"Value must be greater than 0"}
      />
      {/* <span className='number-wrapper'>
                    <input
                        className="seatlimit"
                        type="number"
                        min="0"
                        max="31"
                        step="0.05"
                        onChange={this.handleChange.bind(this, "absenteeismleavecount", 31)}
                        value={this.state.absenteeismleavecount}
                        disabled={!this.state.absenteeismleaveid}
                        title={"Value must be greater than 0"}
                    />
                </span> */}
    </span>
  );

  render() {
    const language = this.props.Language.attendancepolicy;

    return (
      <IntlProvider locale="en" messages={language}>
        <div className="stepper-scroller padding-top-0">
          <div
            className="padding-bottom-30 stepper-scroller-content"
            style={{ width: "80%" }}
          >
            <p className="input-form-label"></p>
            <div className="padding-bottom-30 inner-wrapper opaque">
              <p className="depedent-select-list-head">
                <span style={{ display: "inline-block", width: "80%" }}>
                  <FormattedMessage
                    id="LbDoYouWishAction"
                    defaultMessage="Do you wish to take auto-actions when an employee's logs are not available for a day?"
                  />
                </span>
              </p>
              <div>
                <div
                  className="depedent-select-list"
                  onClick={() => this.handleChange("isabsenteeismrule", true)}
                  aria-expanded={this.state.isabsenteeismrule}
                >
                  <span>
                    <FormattedMessage id="LbYes" defaultMessage="Yes" />
                  </span>
                  {this.state.isabsenteeismrule ? (
                    <span className="floatright">
                      <img src={CheckImg} height="20" />
                    </span>
                  ) : (
                    <span className="not-selected"></span>
                  )}
                </div>
                <div className="et-level2">
                  <Collapse
                    in={this.state.isabsenteeismrule}
                    timeout={2}
                    unmountOnExit
                    className="padding30 overflow-initial"
                    style={{ margin: 0, width: "89%" }}
                  >
                    <p className="depedent-select-list-head">
                      <FormattedMessage
                        id="LbDWouldYouLikeToHandle"
                        defaultMessage="How would you like us to handle No-show situations, when employees don't clock-in for the day and haven't applied for any Leave request either?"
                      />
                    </p>

                    {/* Start Mark Attendance */}
                    <div
                      className="depedent-select-list"
                      onClick={() => this.handleChange("absenteeismtypeid", 1)}
                      aria-expanded={this.state.absenteeismtypeid == 1}
                    >
                      <span>
                        <FormattedMessage
                          id="LbAssumeForgotToClockIn"
                          defaultMessage="Assume employee forgot to clock attendance"
                        />
                      </span>
                      {this.state.absenteeismtypeid == 1 ? (
                        <span className="floatright">
                          <img src={CheckImg} height="20" />
                        </span>
                      ) : (
                        <span className="not-selected"></span>
                      )}
                    </div>
                    <div className="et-level3">
                      <Collapse
                        in={this.state.absenteeismtypeid == 1}
                        timeout={2}
                        unmountOnExit
                        className="padding30 overflow-initial"
                      >
                        <div
                          className="depedent-select-list"
                          onClick={() =>
                            this.handleChange("absenteeismactionid", 1)
                          }
                          aria-expanded={this.state.absenteeismactionid == 1}
                        >
                          <div
                            style={{ width: "95%", display: "inline-block" }}
                          >
                            <FormattedMessage
                              id="__LbAutomaticallyCreateAttendance"
                              defaultMessage="Create an attendance request on behalf of the employee"
                            />
                          </div>
                          {this.state.absenteeismactionid == 1 ? (
                            <div
                              style={{ display: "inline-block" }}
                              className="floatright"
                            >
                              <img src={CheckImg} height="20" />
                            </div>
                          ) : (
                            <div
                              style={{ display: "inline-block" }}
                              className="not-selected"
                            ></div>
                          )}
                        </div>

                        <div
                          className="depedent-select-list"
                          onClick={() =>
                            this.handleChange("absenteeismactionid", 2)
                          }
                          aria-expanded={this.state.absenteeismactionid == 2}
                        >
                          <div
                            style={{ width: "95%", display: "inline-block" }}
                          >
                            <FormattedMessage
                              id="__LbUpdateAttendanceLog"
                              defaultMessage="Automatically update the attendance logs based on the employee's assigned shift timings"
                            />
                          </div>
                          {this.state.absenteeismactionid == 2 ? (
                            <div
                              style={{ display: "inline-block" }}
                              className="floatright"
                            >
                              <img src={CheckImg} height="20" />
                            </div>
                          ) : (
                            <div
                              style={{ display: "inline-block" }}
                              className="not-selected"
                            ></div>
                          )}
                        </div>
                      </Collapse>
                    </div>
                    {/* End Mark Attendance */}

                    {/* Start Mark Leave */}
                    <div
                      className="depedent-select-list"
                      onClick={() => this.handleChange("absenteeismtypeid", 2)}
                      aria-expanded={this.state.absenteeismtypeid == 2}
                    >
                      <span>
                        <FormattedMessage
                          id="LbAssumeWasOnLeave"
                          defaultMessage="Assume employee was on Leave"
                        />
                      </span>
                      {this.state.absenteeismtypeid == 2 ? (
                        <span className="floatright">
                          <img src={CheckImg} height="20" />
                        </span>
                      ) : (
                        <span className="not-selected"></span>
                      )}
                    </div>
                    <div className="et-level3">
                      <Collapse
                        in={this.state.absenteeismtypeid == 2}
                        timeout={2}
                        unmountOnExit
                        className="padding30 overflow-initial"
                      >
                        <div
                          className="depedent-select-list"
                          onClick={() =>
                            this.handleChange("absenteeismactionid", 1)
                          }
                          aria-expanded={this.state.absenteeismactionid == 1}
                        >
                          <div
                            style={{ width: "95%", display: "inline-block" }}
                          >
                            <FormattedMessage
                              id="__LbAutomaticallyCreateLeaveRequest"
                              defaultMessage="Create a leave request on behalf of the employee"
                            />
                          </div>
                          <div style={{ display: "inline-block" }}>
                            {this.state.absenteeismactionid == 1 ? (
                              <span className="floatright">
                                <img src={CheckImg} height="20" />
                              </span>
                            ) : (
                              <span className="not-selected"></span>
                            )}
                          </div>
                        </div>
                        <Collapse
                          in={this.state.absenteeismactionid == 1}
                          timeout={2}
                          unmountOnExit
                          className="padding30 overflow-initial"
                        >
                          {this.RenderLeaveDeduct()}
                        </Collapse>
                        <div
                          className="depedent-select-list"
                          onClick={() =>
                            this.handleChange("absenteeismactionid", 2)
                          }
                          aria-expanded={this.state.absenteeismactionid == 2}
                        >
                          <div
                            style={{ width: "95%", display: "inline-block" }}
                          >
                            <FormattedMessage
                              id="__LbDeductLeaveAndNotify"
                              defaultMessage="Automatically deduct the employee's leave"
                            />
                          </div>
                          {this.state.absenteeismactionid == 2 ? (
                            <div
                              style={{ display: "inline-block" }}
                              className="floatright margin-top-10"
                            >
                              <img src={CheckImg} height="20" />
                            </div>
                          ) : (
                            <div className="not-selected margin-top-10"></div>
                          )}
                        </div>
                        <Collapse
                          in={this.state.absenteeismactionid == 2}
                          timeout={2}
                          unmountOnExit
                          className="padding30 overflow-initial"
                        >
                          {this.RenderLeaveDeduct()}
                        </Collapse>
                      </Collapse>
                    </div>
                    {/* End Mark Leave */}
                  </Collapse>
                </div>
              </div>
              <div>
                <div
                  className="depedent-select-list"
                  onClick={() => this.handleChange("isabsenteeismrule", false)}
                  aria-expanded={!this.state.isabsenteeismrule}
                >
                  <span>
                    <FormattedMessage id="LbNo" defaultMessage="No" />
                  </span>
                  {!this.state.isabsenteeismrule ? (
                    <span className="floatright">
                      <img src={CheckImg} height="20" />
                    </span>
                  ) : (
                    <span className="not-selected"></span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </IntlProvider>
    );
  }
}

Absentieesm.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  InitAttendancePolicy: state.InitAttendancePolicy,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      AttendancePolicyData: (data) => AttendancePolicyData(data),
      CommonReducerAction: (data) => CommonReducerAction(data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(Absentieesm)));
